
import React from 'react';
import "./Forms.scss";
// add .error to component for error state.

const CheckBox = (props) => {
  const { isChecked, label, wrapperClasses, ...otherProps } = props
  return (
    <div className={`form-wrapper ${wrapperClasses}`}>
      <span>
        <input
          type="CheckBox"
          {...otherProps}
          tabIndex='0'
          name={props.name}
          checked={isChecked}
          // defaultChecked={isChecked}
          onClick={(e) => props.onClick(e)}
          onKeyDown = {(e)=> e.key === 'Enter' && props.onClick(e)} />
      </span>
      {label &&
        <label className='checkBox_label'
          htmlFor={props.id}
          for={props.id}
          dangerouslySetInnerHTML={{ __html: label }} />}
    </div>
  );
}
export default CheckBox;
